import { render, staticRenderFns } from "./DisputeViewPhysicalGoods.vue?vue&type=template&id=1763a3ac&"
import script from "./DisputeViewPhysicalGoods.vue?vue&type=script&lang=js&"
export * from "./DisputeViewPhysicalGoods.vue?vue&type=script&lang=js&"
import style0 from "./DisputeViewPhysicalGoods.vue?vue&type=style&index=0&id=1763a3ac&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports